export function index (finished = false, showAll = false, offset = 0, limit = 20, extra, sort)
{
    return axios.get(
        route('api.manage.companies.tasks') + (showAll ? '' : '?filter[assigned_to_me]'),{
        params: {
            'filter[finished]': finished,
            include: 'assignee',
            offset,
            limit,
            sort,
            ...extra
        }
    }).then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.tasks.store'), data)
        .then(response => response.data);
}

export function show(taskId)
{
    return axios.get(route('api.manage.tasks.show'), { taskId });
}

export function update(taskId, data)
{
    return axios.patch(route('api.manage.tasks.update', { taskId }), data)
        .then(response => response.data);
}

export function destroy (taskId)
{
    return axios.delete(route('api.manage.tasks.destroy', { taskId }))
}
